import React from 'react'
import useClickOutside from './hooks/useClickOutside'

const ClickOutside = React.forwardRef(({ callback, children, showLine }, ref) => {
  useClickOutside(ref, callback)
  return <>{children}</>
})

export default React.memo(ClickOutside)
